import { Pricing } from "./Pricing"; 
export const PricingHomePage = () => {
    return (
    <section
      id="pricing"
      className="container mb-16 mt-8 px-4"
    >      
      <h2 className="text-3xl md:text-4xl font-bold text-center">
        Elevate
        <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
          {" "}
          Your Trading{" "}
        </span>
        Today
      </h2>      
      <h3 className="text-xl text-center text-muted-foreground pt-4 pb-8">
        Don't let the market move faster than you.
      </h3>
      <Pricing />
    </section>
    );
}